import { TaskPanel } from '@/components/fleet/task-panel';
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from '@/components/ui/drawer';

/**
 * Task drawer for the playbooks page — opens on a run and live-tails the task
 * via the shared TaskPanel. Closing the drawer does not stop the task.
 */
export function PlaybookTaskDrawer({
  taskId,
  playbookName,
  onClose,
}: {
  taskId: number | null;
  playbookName: string | null;
  onClose: () => void;
}): JSX.Element {
  return (
    <Drawer
      open={taskId !== null}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DrawerContent aria-describedby="playbook-task-desc">
        {taskId !== null && (
          <>
            <DrawerHeader>
              <DrawerTitle>
                {playbookName ?? 'Task'} · task #{taskId}
              </DrawerTitle>
              <DrawerDescription id="playbook-task-desc">
                Live status and output from the Provisioning API.
              </DrawerDescription>
            </DrawerHeader>
            <div className="overflow-y-auto">
              <TaskPanel taskId={taskId} />
            </div>
          </>
        )}
      </DrawerContent>
    </Drawer>
  );
}
